<div class="container u-mt60">
  <div class="row">
      <div class="col-12">
          <div class="breadcrumbs">
              <ul>
                  <li>
                      <a routerLink="/dashboard">
                          Inicio
                      </a>
                  </li>
                  <!-- <li>
                      <a href="">
                          Reportes
                      </a>
                  </li> -->
              </ul>
          </div>
      </div>
      <div class="col-md-12">
          <div class="tabs">
            <!-- <form> -->
              <input *ngIf="availableViews.includes('licenses')" class="state" type="radio" value="licenses" title="tab-one" [formControl]="currentViewControl" id="tab-one" (click)="resetChildForm()" />
              <input *ngIf="availableViews.includes('infractions')" class="state" type="radio" value="infractions" title="tab-two" [formControl]="currentViewControl" id="tab-two" (click)="resetChildForm()" />
              <input *ngIf="availableViews.includes('requests')" class="state" type="radio" value="requests" title="tab-three" [formControl]="currentViewControl" id="tab-three" (click)="resetChildForm()" />
            <!-- </form> -->
              <div class="tabs__group flex-tabs">
                  <label *ngIf="availableViews.includes('licenses')" for="tab-one" id="tab-one-label" class="tab__item">Licencias</label>
                  <label *ngIf="availableViews.includes('infractions')" for="tab-two" id="tab-two-label" class="tab__item">Infracciones</label>
                  <label *ngIf="availableViews.includes('requests')" for="tab-three" id="tab-three-label" class="tab__item">Solicitudes</label>
                  <!--tab one-->
                  <div id="tab-one-panel" class="tab__panel active">
                    <app-reports-licenses
                      [resetFormControl]="resetFormControl"
                      [assetList]="assetList"
                      [zonesList]="zonesList"
                      [gettingZoneList]="gettingZoneList"
                      [stateLicenseList]="stateLicenseList"
                      [gettingItemsList]="gettingItemsList"
                      [assetIdSelectedControl]="assetIdSelectedControl"
                    >
                    </app-reports-licenses>
                  </div>
                  <!--tab one-->
                  <!--tab two-->
                  <div id="tab-two-panel" class="tab__panel">
                    <app-reports-infractions
                      [resetFormControl]="resetFormControl"
                      [assetList]="assetList"
                      [zonesList]="zonesList"
                      [gettingZoneList]="gettingZoneList"
                      [gettingSeverityList]="gettingSeverityList"
                      [gettingSanctionList]="gettingSanctionList"
                      [severityInfractionsList]="severityInfractionsList"
                      [typeSanctionList]= "typeSanctionList"
                      [gettingItemsList]="gettingItemsList"
                      [assetIdSelectedControl]="assetIdSelectedControl"
                    >
                    </app-reports-infractions>
                  </div>

                  <!--tab two-->
                  <!--tab three-->
                  <div id="tab-three-panel" class="tab__panel">
                    <app-reports-requests
                      [resetFormControl]="resetFormControl"
                      [gettingItemsList]="gettingItemsList"
                      [assetList]="assetList"
                      [typeRequestList]="typeRequestList"
                      [stateRequestList]="stateRequestList"
                      [assetIdSelectedControl]="assetIdSelectedControl"
                    >
                    </app-reports-requests>
                  </div>
                  <!--tab three-->
              </div>
          </div>
      </div>
  </div>
</div>
